<template>
	<div style="width: 1000px;margin-right: 20px;">
		<cTable
		  :fields="fields"
		  :config="config"
		  :footer="footer"
			ref='table'
		>
		</cTable>
	</div>
  
</template>

<script>
	import cTable from "@/base/common/index";
export default {
  name: "flow",
  components: {
    cTable,
  },
	props:{
		list:{
			type:Array,
			default:()=>[]
		},
		height:{
			type:Number,
			default:580
		}
	},
	mounted() {
		this.$refs['table'].list = this.list
	},
  data() {
    let that = this;
    return {
      config: {
				height:this.height,
				resize:false,
				slot:'div',
        showOverflow: false,
      },
      footer: {
        show: () => false,
      },
      fields: [
				{
				  type: "seq",
					width:50
				},
				{
				  name: () => this.$t("approver"),
				  key: "user_name",
				},
				{
				  name: () => this.$t("CurrentState"),
				  key: "status",
					methods:{
						render({value}){
							let name = ['ApprovalPending','Passed','Rejected','alreadyRepeal']
							return this.$t(name[value]) 
						}
					}
				},
				{
				  name: () => this.$t("approval_time"),
				  key: "check_time",
				},
				{
				  name: () => this.$t("approval_remark"),
				  key: "notes",
				},
      ],
    };
  },
};
</script>
